<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <lote-certificado-editar-form @success="success"></lote-certificado-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <lote-certificado-editar-form @success="success"></lote-certificado-editar-form>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'lote-certificado-editar-form': require('./LoteCertificadoEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
